export default {
  workstation: {
    tabs: {
      workstation: "Workstation",
      trend: "Trend",
    },
    filters: {
      with: "Con",
      without: "Senza",
      splits: "Split",
      none: "Nessuno",
    },
    sections: {
      gamelog: "Registro partite",
    },
    headers: {
      line: "Linea",
      opponent: "Avversario",
    },
    labels: {
      averagePerGame: "Media per partita",
      cover: "Copertura",
    },
  },
};
